(() => {
  const bar = document.querySelector('.ruff-mobile-buy');
  const info = document.querySelector('.product__info-container');
  const title = info?.querySelector('.product__title');
  const submit = info?.querySelector('.product-form__submit');
  const link = bar?.querySelector('[data-ruff-choose-options]');
  if (!bar || !info || !submit || !link || !title) return;
  let buyVisible = false;
  let titleReached = false;
  const update = () => {
    const cartOpen = document.querySelector('cart-drawer.active, cart-notification.active, .product-media-modal[open], modal-dialog[open]');
    bar.hidden = !titleReached || buyVisible || !!cartOpen;
  };
  new IntersectionObserver(([entry]) => {
    buyVisible = entry.isIntersecting;
    update();
  }, {threshold: 0.1}).observe(submit);
  new IntersectionObserver(([entry]) => {
    titleReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
    update();
  }, {threshold: 0.1}).observe(title);
  new MutationObserver(update).observe(document.body, {
    subtree: true, attributes: true, attributeFilter: ['class', 'open']
  });
  link.addEventListener('click', event => {
    const options = info.querySelector('variant-selects') || info;
    if (!options) return;
    event.preventDefault();
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    options.scrollIntoView({behavior: reduced ? 'instant' : 'smooth', block: 'center'});
  });
})();
